import Promo from "../../components/Promo"
import About from "./components/about/About"
import Featured from "./components/featured/Featured"
// import Hero from "./components/hero/Hero"
import Sponsor from "./components/sponsors/Sponsor"
import Videos from "./components/videos/Videos"
import Slides from "./components/slides/Slides"

const Home = () => {
  return (
    <div>
      {/* <Hero /> */}
      <Slides />
      <Featured />
      <About />
      <Videos />
      <Sponsor />
      <Promo />
    </div>
  )
}

export default Home